import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import styled from 'styled-components'

const client = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60000,
			gcTime: 60000,
		},
	},
})

function AppWrapper({ children }: AppWrapperProps) {
	return (
		<GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY!}>
			<QueryClientProvider client={client}>
				{children}
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</GoogleReCaptchaProvider>
	)
}

export default styled(AppWrapper)``
